import React, {PureComponent} from 'react';
import {withStyles} from 'material-ui/styles';
import {DialogActions} from 'material-ui/Dialog';
import DialogActionsNew from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogActions'
import GridOld from 'material-ui/Grid';
import Grid from "housecall-ui/dist/DesignSystem/Layout/Grid/Grid"
import PropTypes from 'prop-types'

const styles = theme => ({
    dialogAction: {
        width: '100%',
        paddingLeft: 8
    }
})
@withStyles(styles)
export default class FullWidthDialogActions extends PureComponent {
    render() {
        const {classes, useLatestMaterialUI} = this.props
        if(useLatestMaterialUI) {
            return (
                <DialogActionsNew>
                    <Grid container justify="space-between" alignItems='center'>
                        <Grid item>
                            {this.props.leftComponent}
                        </Grid>
                        <Grid item>
                            {this.props.rightComponent}
                        </Grid>
                    </Grid>
                </DialogActionsNew>)
        } else {
            return (
            <DialogActions classes={{ action: classes.dialogAction }}>
                <GridOld container justify="space-between" alignItems='center'>
                    <GridOld item>
                        {this.props.leftComponent}
                    </GridOld>
                    <GridOld item>
                        {this.props.rightComponent}
                    </GridOld>
                </GridOld>
            </DialogActions>)
        }
    }
}


FullWidthDialogActions.propTypes = {
    leftComponent: PropTypes.element,
    rightComponent: PropTypes.element
};
